import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import { Dialog } from "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { useDeleteAppointment } from "../../hooks/useDeleteAppointment.js";
import { StyledTypography } from "./appointment-deletion-dialog.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "@tanstack/react-query";
import "../../providers/axios-provider.js";
import "axios";
const AppointmentDeletionDialog = ({
  onCancel,
  onSave,
  appointment,
  labels,
  isOpenAppointment
}) => {
  const { mutateAsync: deleteAppointment, isLoading: isDeleting } = useDeleteAppointment({
    id: appointment == null ? void 0 : appointment.referenceId,
    isOpenAppointment
  });
  const handleClose = (event) => {
    event.stopPropagation();
    onCancel();
  };
  const handleClick = (event) => {
    event.stopPropagation();
  };
  const handleDeleteAppointment = async () => {
    await deleteAppointment();
    onSave();
  };
  const title = useMemo(() => isOpenAppointment ? labels.openAppointmentTitle : labels.title, [isOpenAppointment]);
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open: true,
      onClose: handleClose,
      onCancel,
      onClick: handleClick,
      onSave: handleDeleteAppointment,
      disabled: isDeleting,
      labels: labels.buttons,
      width: 480,
      children: /* @__PURE__ */ jsx(Box, { mt: 2, mb: 2, children: /* @__PURE__ */ jsx(StyledTypography, { variant: "Lato Body 1", children: title }) })
    }
  );
};
export {
  AppointmentDeletionDialog
};
